enum Gender {
  Male,
  Female,
  Other,
}

export default Gender;
